import React from 'react'
import Restourent from './component/Basics/Restourent'
const App = () => {
  return (
    <Restourent />
  )
}

export default App
